import { render, staticRenderFns } from "./FilterTab.vue?vue&type=template&id=cb77681a&"
import script from "./FilterTab.vue?vue&type=script&lang=js&"
export * from "./FilterTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports